import { render } from "./recollectAutomation.vue?vue&type=template&id=71e78818"
import script from "./recollectAutomation.vue?vue&type=script&lang=js"
export * from "./recollectAutomation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__